<script setup>
import useApp from "../composables/useApp";

const props = defineProps({
    calendars: {
        type: Boolean,
        default: false,
    },
})

const { useSimpleBanner } = useApp();
</script>

<template>
    <section class="-mx-4 pt-8">
        <div class="grid gap-2 lg:gap-0 grid-cols-2 mb-2 sm:mb-8 items-center place-items-center sm:-mt-4">
            <div>
                <div class="mb-7">
                    <h1 class="font-bi-head-bold text-bi-dark-green"
                        :class="'text-[5vw] leading-[5.5vw] sm:text-[26px] sm:leading-[34px] lg:text-[30px] lg:leading-[38px]'"
                        v-html="$t('home.title')">
                    </h1>
                </div>

                <div class="sr-only sm:not-sr-only text-bi-dark-green" v-if="calendars">
                    <h2 class="font-bi-text-bold text-base sm:text-lg">
                        {{ $t('home.subtitle') }}
                    </h2>

                    <p class="text-sm sm:text-base" v-html="$t('home.subtitle.copy')"></p>
                </div>
            </div>

                <img src="../../images/dog-and-cat.png" class="w-full h-auto xs:mt-8"
                     :alt="$t('home.title').replace(/<[^>]+>/g, '')" />
        </div>

        <div class="not-sr-only sm:sr-only mb-8 sm:mb-0 text-bi-dark-green" v-if="!useSimpleBanner">
            <h2 class="font-bi-text-bold text-base sm:text-lg">
                {{ $t('home.subtitle') }}
            </h2>

            <p class="text-sm sm:text-base" v-html="$t('home.subtitle.copy')">

            </p>
        </div>
    </section>

    <section class="mt-4" v-if="calendars && !useSimpleBanner">
        <p class="text-center text-sm sm:text-base text-bi-dark-green font-bi-text-medium mb-[12px]">
            {{ $t('home.calendars') }}
        </p>

        <div class="flex items-start justify-around sm:justify-center gap-4 sm:gap-8">
            <div class="flex flex-col gap-[12px] items-center w-1/3 sm:max-w-[115px]">
                <img src="../../images/calendar-ios.png" alt="iOS Calendar" width="64" class="w-[48px] sm:w-[64px]">
                <span class="text-xs sm:text-sm text-bi-dark-green text-center" v-html="$t('home.calendar.ios')"></span>
            </div>

            <div class="flex flex-col gap-[12px] items-center w-1/3 sm:max-w-[115px]">
                <img src="../../images/calendar-google.png" alt="Google Calendar" width="64" class="w-[48px] sm:w-[64px]">
                <span class="text-xs sm:text-sm text-bi-dark-green text-center"
                    v-html="$t('home.calendar.google')"></span>
            </div>

            <div class="flex flex-col gap-[12px] items-center w-1/3 sm:max-w-[115px]">
                <img src="../../images/calendar-outlook.png" alt="Outlook Calendar" width="64" class="w-[48px] sm:w-[64px]">
                <span class="text-xs sm:text-sm text-bi-dark-green text-center"
                    v-html="$t('home.calendar.outlook')"></span>
            </div>
        </div>
    </section>
</template>

<style scoped>
br {
    @apply sm:hidden;
}
</style>
